import { render, staticRenderFns } from "./PaqueteDocumentoExport.vue?vue&type=template&id=648565db"
import script from "./PaqueteDocumentoExport.vue?vue&type=script&lang=js"
export * from "./PaqueteDocumentoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports